import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import Domain from "@material-ui/icons/Domain";
import { useAttendanceLocalList } from "../../../services/api-tansquery/attendance-local/list";
import AttendanceLocalListTableActions from "./components/table-action";
import SearchField from "../components/search-field";
import { useAttendanceLocalStyles } from "../styles";
import { useAttendanceLocalListStyles } from "./styles";
import CustomPagination from "../../../Components/pagination";
import { dateformat } from "../../../utils/dateFormat";
import { useBreadcrumbs } from "../../../contexts/breadcrumb";
import EmptyState from "../../../Components/EmptyState";
import { usePermission } from "../../../hooks/usePermission";

export default function AttendanceLocalList() {
    const history = useHistory();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { pathname } = useLocation();
    const { isAboveCoordenator } = usePermission();
    const { classes } = useAttendanceLocalListStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: attendanceLocalList } = useAttendanceLocalList();

    const isEmptyLocals = (attendanceLocalList?.results ?? []).length === 0;
    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
            ];
        });
    }, [setBreadcrumbs]);

    return (
        <Box>
            <Box className={classes.header}>
                <Typography className={classes.title}>Locais de Atendimento</Typography>
                {isAboveCoordenator && (
                    <Button
                        startIcon={<AddCircle />}
                        className={defaultClasses.addButton}
                        onClick={() => history.push(`${pathname}/novo`)}
                    >
                        Novo Local
                    </Button>
                )}
            </Box>
            <Paper elevation={3}>
                <SearchField placeholder="Buscar por nome,cidade ou orgão..." />
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>
                                    Local de Atendimento
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>Cidade</TableCell>
                                <TableCell className={defaultClasses.tableTH}>Ativo</TableCell>
                                <TableCell className={defaultClasses.tableTH}>Sigla orgão</TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Adicionado
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Atualizado
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {attendanceLocalList?.results.map((attendanceLocal) => (
                                <TableRow
                                    hover
                                    key={attendanceLocal.slug_unidade}
                                    role="checkbox"
                                    tabIndex={-1}
                                >
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendanceLocal.nome}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendanceLocal?.cidade?.cidade}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <Box
                                            className={`${defaultClasses.badge} ${attendanceLocal.ativo
                                                ? defaultClasses.active
                                                : defaultClasses.inactive
                                                }`}
                                        >
                                            {attendanceLocal.ativo ? "Sim" : "Não"}
                                        </Box>
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {attendanceLocal?.orgao?.sigla}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(attendanceLocal.created_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(attendanceLocal.updated_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <AttendanceLocalListTableActions
                                            slug={attendanceLocal.slug_unidade}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmptyLocals && (
                        <EmptyState message="Nenhum local de atendimento encontrado." />
                    )}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={attendanceLocalList?.count}
                        page={attendanceLocalList?.current}
                        totalPages={attendanceLocalList?.total_pages}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
